// extracted by mini-css-extract-plugin
export default {"dragger":"drag_dragger__mc2XR","draggerDisabled":"drag_draggerDisabled__KFaWf","uploadArrow":"drag_uploadArrow__ebOYy","bold":"drag_bold__Cwgtt"};